import {
  LIST_GENERAL_FEE_REQUEST,
  LIST_GENERAL_FEE_SUCCESS,
  LIST_GENERAL_FEE_FAIL,
  LIST_GENERAL_FEE_SUMMARY_REQUEST,
  LIST_GENERAL_FEE_SUMMARY_SUCCESS,
  LIST_GENERAL_FEE_SUMMARY_FAIL,
  CREATE_GENERAL_FEE_REQUEST,
  CREATE_GENERAL_FEE_SUCCESS,
  CREATE_GENERAL_FEE_FAIL,
  DETAIL_GENERAL_FEE_REQUEST,
  DETAIL_GENERAL_FEE_SUCCESS,
  DETAIL_GENERAL_FEE_FAIL,
  UPDATE_GENERAL_FEE_REQUEST,
  UPDATE_GENERAL_FEE_SUCCESS,
  UPDATE_GENERAL_FEE_FAIL,
  DELETE_GENERAL_FEE_REQUEST,
  DELETE_GENERAL_FEE_SUCCESS,
  DELETE_GENERAL_FEE_FAIL,
  RESET_GENERAL_FEE
} from '../../constants/general-price-setup'

const initialState = {
  loading: false,
  generalPriceSetups: [],
  generalPriceSetupSummary: [],
  generalPriceSetup: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const generalPriceSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_GENERAL_FEE_REQUEST:
      return { ...state, loading: true }
    case LIST_GENERAL_FEE_SUCCESS:
      return {
        ...state,
        loading: false,
        generalPriceSetups: action.payload,
        pageable: action.pageable
      }
    case LIST_GENERAL_FEE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        generalPriceSetups: action?.dummy
      }
    case LIST_GENERAL_FEE_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_GENERAL_FEE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        generalPriceSetupSummary: action.payload,
        error: null
      }
    case LIST_GENERAL_FEE_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_GENERAL_FEE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_GENERAL_FEE_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_GENERAL_FEE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_GENERAL_FEE_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_GENERAL_FEE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        error: null,
        generalPriceSetup: action.payload
      }
    case DETAIL_GENERAL_FEE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_GENERAL_FEE_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_GENERAL_FEE_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_GENERAL_FEE_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_GENERAL_FEE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_GENERAL_FEE_SUCCESS:
      const generalFeeIdDelete = action.payload
      const generalFeesDelete = [...state.generalPriceSetups]

      const indexDelete = generalFeesDelete.findIndex(
        (generalPriceSetup) => generalPriceSetup.id === generalFeeIdDelete
      )
      generalFeesDelete.splice(indexDelete, 1)
      return {
        ...state,
        loadingDelete: false,
        generalPriceSetups: generalFeesDelete,
        error: null
      }
    case DELETE_GENERAL_FEE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_GENERAL_FEE:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default generalPriceSetupReducer
